
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import LaunchButton from '@/components/LaunchButton';

const PricingComparisonSection = ({ onPricingClick }: { onPricingClick: () => void }) => {
  return (
    <section className="py-16 px-4 bg-gradient-to-b from-white to-muted/20">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Why Pay More for Individual Subscriptions?</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Get access to multiple AI models at a fraction of the cost
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-8">
          {/* Left side - Purchased Individually */}
          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4 text-center">Purchased Individually</h3>
            <div className="text-center mb-6">
              <p className="text-4xl font-bold text-red-500">Rs. 8,600+/mon</p>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span>Claude AI:</span>
                <span>Rs. 2,500/mon</span>
              </div>
              <div className="flex justify-between">
                <span>OpenAI:</span>
                <span>Rs. 1,700/mon</span>
              </div>
              <div className="flex justify-between">
                <span>Gemini:</span>
                <span>Rs. 1,700/mon</span>
              </div>
              <div className="flex justify-between">
                <span>Model Hosting:</span>
                <span>Rs. 3,300/mon</span>
              </div>
            </div>
          </div>
          
          {/* Right side - Krix AI */}
          <div className="bg-white rounded-xl shadow-md p-6 border-2 border-krix-purple">
            <h3 className="text-xl font-semibold mb-4 text-center">Krix AI</h3>
            <div className="text-center mb-6">
              <p className="text-4xl font-bold text-krix-purple">Starting Rs. 250/mon</p>
            </div>
            <div className="space-y-3">
              <div className="flex items-start">
                <span className="text-krix-purple mr-2">✓</span>
                <span>Claude AI</span>
              </div>
              <div className="flex items-start">
                <span className="text-krix-purple mr-2">✓</span>
                <span>OpenAI</span>
              </div>
              <div className="flex items-start">
                <span className="text-krix-purple mr-2">✓</span>
                <span>Gemini Advanced</span>
              </div>
              <div className="flex items-start">
                <span className="text-krix-purple mr-2">✓</span>
                <span>DeepSeek, Qwen and more</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Money-back guarantee section */}
        <div className="flex items-center justify-center gap-2 mt-4 mb-8 text-green-600">
          <ShieldCheck className="h-6 w-6" />
          <p className="text-md font-medium">
            All plans include our 7-day money-back guarantee
          </p>
        </div>
        
        {/* Button */}
        <div className="text-center">
          <LaunchButton
            variant="default"
            size="lg"
            className="mx-auto"
            onClick={onPricingClick}
          >
            See Our Plans
          </LaunchButton>
        </div>
      </div>
    </section>
  );
};

export default PricingComparisonSection;
